"use strict";

var _createForOfIteratorHelper = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _regeneratorRuntime = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _slicedToArray = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _asyncToGenerator = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _createClass = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _classCallCheck = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _assertThisInitialized = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _inherits = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var _wrapNativeSuper = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapNativeSuper");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AwaitQueue = exports.AwaitQueueRemovedTaskError = exports.AwaitQueueStoppedError = void 0;

var Logger_1 = require("./Logger");

var logger = new Logger_1.Logger();
/**
 * Custom Error derived class used to reject pending tasks once stop() method
 * has been called.
 */

var AwaitQueueStoppedError = /*#__PURE__*/function (_Error) {
  _inherits(AwaitQueueStoppedError, _Error);

  var _super = _createSuper(AwaitQueueStoppedError);

  function AwaitQueueStoppedError(message) {
    var _this;

    _classCallCheck(this, AwaitQueueStoppedError);

    _this = _super.call(this, message !== null && message !== void 0 ? message : 'AwaitQueue stopped');
    _this.name = 'AwaitQueueStoppedError'; // @ts-ignore

    if (typeof Error.captureStackTrace === 'function') {
      // @ts-ignore
      Error.captureStackTrace(_assertThisInitialized(_this), AwaitQueueStoppedError);
    }

    return _this;
  }

  return AwaitQueueStoppedError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

exports.AwaitQueueStoppedError = AwaitQueueStoppedError;
/**
 * Custom Error derived class used to reject pending tasks once removeTask()
 * method has been called.
 */

var AwaitQueueRemovedTaskError = /*#__PURE__*/function (_Error2) {
  _inherits(AwaitQueueRemovedTaskError, _Error2);

  var _super2 = _createSuper(AwaitQueueRemovedTaskError);

  function AwaitQueueRemovedTaskError(message) {
    var _this2;

    _classCallCheck(this, AwaitQueueRemovedTaskError);

    _this2 = _super2.call(this, message !== null && message !== void 0 ? message : 'AwaitQueue task removed');
    _this2.name = 'AwaitQueueRemovedTaskError'; // @ts-ignore

    if (typeof Error.captureStackTrace === 'function') {
      // @ts-ignore
      Error.captureStackTrace(_assertThisInitialized(_this2), AwaitQueueRemovedTaskError);
    }

    return _this2;
  }

  return AwaitQueueRemovedTaskError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

exports.AwaitQueueRemovedTaskError = AwaitQueueRemovedTaskError;

var AwaitQueue = /*#__PURE__*/function () {
  function AwaitQueue() {
    _classCallCheck(this, AwaitQueue);

    // Queue of pending tasks (map of PendingTasks indexed by id).
    this.pendingTasks = new Map(); // Incrementing PendingTask id.

    this.nextTaskId = 0; // Whether stop() method is stopping all pending tasks.

    this.stopping = false;
  }

  _createClass(AwaitQueue, [{
    key: "push",
    value: function () {
      var _push = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(task, name) {
        var _this3 = this;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                name = name !== null && name !== void 0 ? name : task.name;
                logger.debug("push() [name:".concat(name, "]"));

                if (!(typeof task !== 'function')) {
                  _context.next = 4;
                  break;
                }

                throw new TypeError('given task is not a function');

              case 4:
                if (name) {
                  try {
                    Object.defineProperty(task, 'name', {
                      value: name
                    });
                  } catch (error) {}
                }

                return _context.abrupt("return", new Promise(function (_resolve, _reject) {
                  var pendingTask = {
                    id: _this3.nextTaskId++,
                    task: task,
                    name: name,
                    enqueuedAt: Date.now(),
                    executedAt: undefined,
                    completed: false,
                    resolve: function resolve(result) {
                      // pendingTask.resolve() can only be called in execute() method. Since
                      // resolve() was called it means that the task successfully completed.
                      // However the task may have been stopped before it completed (via
                      // stop() or remove()) so its completed flag was already set. If this
                      // is the case, abort here since next task (if any) is already being
                      // executed.
                      if (pendingTask.completed) {
                        return;
                      }

                      pendingTask.completed = true; // Remove the task from the queue.

                      _this3.pendingTasks.delete(pendingTask.id);

                      logger.debug("resolving task [name:".concat(pendingTask.name, "]")); // Resolve the task with the obtained result.

                      _resolve(result); // Execute the next pending task (if any).


                      var _this3$pendingTasks$v = _this3.pendingTasks.values(),
                          _this3$pendingTasks$v2 = _slicedToArray(_this3$pendingTasks$v, 1),
                          nextPendingTask = _this3$pendingTasks$v2[0]; // NOTE: During the resolve() callback the user app may have interacted
                      // with the queue. For instance, the app may have pushed a task while
                      // the queue was empty so such a task is already being executed. If so,
                      // don't execute it twice.


                      if (nextPendingTask && !nextPendingTask.executedAt) {
                        void _this3.execute(nextPendingTask);
                      }
                    },
                    reject: function reject(error) {
                      // pendingTask.reject() can be called within execute() method if the
                      // task completed with error. However it may have also been called in
                      // stop() or remove() methods (before or while being executed) so its
                      // completed flag was already set. If so, abort here since next task
                      // (if any) is already being executed.
                      if (pendingTask.completed) {
                        return;
                      }

                      pendingTask.completed = true; // Remove the task from the queue.

                      _this3.pendingTasks.delete(pendingTask.id);

                      logger.debug("rejecting task [name:".concat(pendingTask.name, "]: %s"), String(error)); // Reject the task with the obtained error.

                      _reject(error); // Execute the next pending task (if any) unless stop() is running.


                      if (!_this3.stopping) {
                        var _this3$pendingTasks$v3 = _this3.pendingTasks.values(),
                            _this3$pendingTasks$v4 = _slicedToArray(_this3$pendingTasks$v3, 1),
                            nextPendingTask = _this3$pendingTasks$v4[0]; // NOTE: During the reject() callback the user app may have interacted
                        // with the queue. For instance, the app may have pushed a task while
                        // the queue was empty so such a task is already being executed. If so,
                        // don't execute it twice.


                        if (nextPendingTask && !nextPendingTask.executedAt) {
                          void _this3.execute(nextPendingTask);
                        }
                      }
                    }
                  }; // Append task to the queue.

                  _this3.pendingTasks.set(pendingTask.id, pendingTask); // And execute it if this is the only task in the queue.


                  if (_this3.pendingTasks.size === 1) {
                    void _this3.execute(pendingTask);
                  }
                }));

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function push(_x, _x2) {
        return _push.apply(this, arguments);
      }

      return push;
    }()
  }, {
    key: "stop",
    value: function stop() {
      logger.debug('stop()');
      this.stopping = true;

      var _iterator = _createForOfIteratorHelper(this.pendingTasks.values()),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var pendingTask = _step.value;
          logger.debug("stop() | stopping task [name:".concat(pendingTask.name, "]"));
          pendingTask.reject(new AwaitQueueStoppedError());
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      this.stopping = false;
    }
  }, {
    key: "remove",
    value: function remove(taskIdx) {
      logger.debug("remove() [taskIdx:".concat(taskIdx, "]"));
      var pendingTask = Array.from(this.pendingTasks.values())[taskIdx];

      if (!pendingTask) {
        logger.debug("stop() | no task with given idx [taskIdx:".concat(taskIdx, "]"));
        return;
      }

      pendingTask.reject(new AwaitQueueRemovedTaskError());
    }
  }, {
    key: "dump",
    value: function dump() {
      var now = Date.now();
      var idx = 0;
      return Array.from(this.pendingTasks.values()).map(function (pendingTask) {
        return {
          idx: idx++,
          task: pendingTask.task,
          name: pendingTask.name,
          enqueuedTime: pendingTask.executedAt ? pendingTask.executedAt - pendingTask.enqueuedAt : now - pendingTask.enqueuedAt,
          executionTime: pendingTask.executedAt ? now - pendingTask.executedAt : 0
        };
      });
    }
  }, {
    key: "execute",
    value: function () {
      var _execute = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(pendingTask) {
        var result;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                logger.debug("execute() [name:".concat(pendingTask.name, "]"));

                if (!pendingTask.executedAt) {
                  _context2.next = 3;
                  break;
                }

                throw new Error('task already being executed');

              case 3:
                pendingTask.executedAt = Date.now();
                _context2.prev = 4;
                _context2.next = 7;
                return pendingTask.task();

              case 7:
                result = _context2.sent;
                // Resolve the task with its resolved result (if any).
                pendingTask.resolve(result);
                _context2.next = 14;
                break;

              case 11:
                _context2.prev = 11;
                _context2.t0 = _context2["catch"](4);
                // Reject the task with its rejected error.
                pendingTask.reject(_context2.t0);

              case 14:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[4, 11]]);
      }));

      function execute(_x3) {
        return _execute.apply(this, arguments);
      }

      return execute;
    }()
  }, {
    key: "size",
    get: function get() {
      return this.pendingTasks.size;
    }
  }]);

  return AwaitQueue;
}();

exports.AwaitQueue = AwaitQueue;